import Tooltip from "rc-tooltip";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import CommentsComponent from "../../../components/comments";
import InfoIcon from "../../../components/icons/InfoIcon";

interface Props extends RouteComponentProps<{ id: string }> {}

const LocationCommentsTab: React.FC<Props> = (props) => {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
      <div className="mt-6 pb-5">
        <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white flex items-center">
          Internal workspace comments
          <Tooltip overlay="These comments are only available from within this workspace">
            <InfoIcon className="ml-1 inline-flex h-4 w-4" />
          </Tooltip>
        </h3>
        <p className="mt-2 max-w-4xl text-sm text-gray-500 dark:text-gray-300">
          Use the comments section to save text information relevant to this
          location. For example, “no internet available in this location”.
          Tagging other workspace members using the <b>@ sign</b> emails them
          the comment which is great for collaboration.
        </p>
      </div>

      <CommentsComponent type="location" typeUuid={props.match.params.id} />
    </div>
  );
};

export default LocationCommentsTab;
